// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__HiKXY","button":"Header_button__1tkrO","camera":"Header_camera__1-3A8"};